import { useQuery } from '@tanstack/react-query';

import { blogTagsQueryOptions } from '#features/blog/model/blog';

export const useBlogTags = () => {
  const { data } = useQuery(blogTagsQueryOptions());
  return data ?? [];
};
